import {$$} from '@vue-macros/reactivity-transform/macros'

import {PropertyStrategyComponentType} from '@toolify/client/src/modules/tableItems/enum/PropertyStrategyComponentType'
import {
  IFormulaPropertyTypeInterfaces,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/ComputedPropertyTypeStrategy/types/IFormulaPropertyTypeInterfaces'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterGroupOperator} from '@toolify/server/src/services/FilterService/enum/FilterGroupOperator'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {IDatabasePropertyResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'
import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {DatabaseViewType} from '@toolify/server/src/models/mongoose/DatabaseViewModel/enum/DatabaseViewType'
export function useComputedValueTypeStrategy() {
  const strategyComponentType = PropertyStrategyComponentType.Input

  const fullValueToText = (value: unknown) => {
    if([null, undefined].includes(value)) {
      return ''
    }
    return String(value || '')
  }

  const getDisplayValue = (value: unknown, propertyOptions: IFormulaPropertyTypeInterfaces['options'], shouldFormat = true) => {
    if([null, undefined].includes(value)) {
      return null
    }
    if(!propertyOptions) {
      return value
    }
    const {round, prefix, suffix} = propertyOptions
    if(round !== null && typeof value === 'number') {
      value = (value).toFixed(round)
    }
    if(prefix && ![null, undefined, ''].includes(value as string) && shouldFormat) {
      value = `${prefix}${value}`
    }
    if(suffix && ![null, undefined, ''].includes(value as string) && shouldFormat) {
      value = `${value}${suffix}`
    }
    return value
  }

  const searchToFilterQuery = (search: string, databaseProperties: IDatabasePropertyResponseInstance[]): IFilter => {
    return {
      type: FilterItemType.Group,
      operator: FilterGroupOperator.Or,
      items: databaseProperties.map(databaseProperty => {
        return {
          type: FilterItemType.Property,
          id: databaseProperty.id,
          subProperty: '',
          operator: {
            type: FilterPropertyOperator.RegExp,
          },
          payload: {
            type: FilterPropertyPayloadType.Static,
            value: search,
          },
          isDisabled: false,
        }
      }),
    }
  }

  const canGroupByView = (viewType: DatabaseViewType, _property: IDatabasePropertyResponseInstance) =>
    viewType === DatabaseViewType.Table
  const getAdditionalPropertyIdsToFetch = (property: IDatabasePropertyResponseInstance): string[] => {
    const options = property.valueTypeOptions as IFormulaPropertyTypeInterfaces['options']
    if(!options?.expression) {
      return []
    }
    const matches = options.expression.match(/COLUMN\((.+?)\)/g)
    if(!matches) {
      return []
    }
    return matches.map(match => match.replace(/COLUMN\((.+?)\)/, '$1'))
  }
  return $$({
    fullValueToText,
    strategyComponentType,
    getDisplayValue,
    searchToFilterQuery,
    canGroupByView,
    getAdditionalPropertyIdsToFetch,
  })
}
